import { APP_INITIALIZER, Provider } from '@angular/core';

import { WebAuthService } from './auth.service';

export function authAppInitFactory(authService: WebAuthService) {
  return () => authService.init();
}

export const authServiceAppInitProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: authAppInitFactory,
  deps: [WebAuthService],
  multi: true,
};
